import axiosInstance from '../../../utils/apiConfig';

const doctorsApi = {
  // Get all doctors associated with a partner
  getByPartner: (partnerId, params) =>
    axiosInstance
      .get(`/b2b/partners/${partnerId}/doctors`, { params })
      .then((res) => res.data),

  // Associate doctors with partner
  associate: (partnerId, doctorIds) =>
    axiosInstance
      .post(`/b2b/partners/${partnerId}/doctors`, {
        doctor_ids: doctorIds,
      })
      .then((res) => res.data),

  // Dissociate doctor from partner
  dissociate: (partnerId, doctorId) =>
    axiosInstance
      .delete(`/b2b/partners/${partnerId}/doctors/${doctorId}`)
      .then((res) => res.data),

  // Get available doctors (not associated with this partner)
  getAvailable: (partnerId, params) =>
    axiosInstance
      .get(`/b2b/partners/${partnerId}/doctors/available`, { params })
      .then((res) => res.data),

  // Search all doctors (for association)
  search: (keyword) =>
    axiosInstance
      .get('/admin/users/doctors/search', { params: { keyword } })
      .then((res) => res.data),

  // Bulk associate doctors
  bulkAssociate: (partnerId, doctorIds) =>
    axiosInstance
      .post(`/b2b/partners/${partnerId}/doctors/bulk`, {
        doctor_ids: doctorIds,
      })
      .then((res) => res.data),
};

export default doctorsApi;